import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "@/services/api/apiService";

interface Ingredient {
    ingredientName: string,
    ingredientTypeName: string,
    allergenTypeId: any;
    id: number
}
interface ingredientState {
    data: Ingredient[],
    loading: boolean,
    error: string | null | {},
}
interface ApiResponse {
    data: Ingredient[];
}

const PORT = import.meta.env.VITE_COOK_PORT;
const MASTERURL = import.meta.env.VITE_API_COOK_URL;



export const fetchIngredient = createAsyncThunk<Ingredient[]>(
    'ingredient/fetchIngredient',
    async (_id, { rejectWithValue }) => {
        try {
            const response = await apiService.get<ApiResponse>('/get_all_ingredient', PORT, MASTERURL);
            return response.data;
        } catch (error) {
            return rejectWithValue("not updated");
        }
    }
);

export const createIngredient = createAsyncThunk(
    'ingredient/createIngredient',
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await apiService.post<ApiResponse>('/create_ingredient', payload, PORT, MASTERURL);
            return response.data
        }
        catch (error) {
            return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');

        }
    }
);

export const updateIngredient = createAsyncThunk(
    'ingredient/updateIngredient',
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await apiService.put<ApiResponse>(
                '/update_ingredient',
                payload,
                PORT,
                MASTERURL
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'An error occurred'
            );
        }
    }
);


export const softDeleteIngredient: any = createAsyncThunk<
    number,
    number
>(
    "Ingredient/softDeleteIngredient",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_ingredient?id=${id}`,
                {},
                PORT,
                MASTERURL
            );

            return response



        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);

export const ingredientSlice = createSlice({
    name: "ingredient",
    initialState: {
        data: [] as Ingredient[],
        loading: false,
        error: null,
    } as ingredientState,
    reducers: {},
    extraReducers: ((builder) => {
        builder
            .addCase(fetchIngredient.pending, (state) => {
                state.loading = true,
                    state.error = null
            })
            .addCase(fetchIngredient.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(fetchIngredient.rejected, (state, action) => {
                state.loading = false
                state.error = action.payload ?? "UnKnow Error"

            })
    })

})

export default ingredientSlice.reducer;